module.exports = __webpack_public_path__ + "img/pic.d0289dc0.png";